import HeaderCat from './HeaderCat';
import FaqCategorie from './FaqCategorie';
import '../assets/categories.css';
import '../assets/faqCategorie.css';
import SeeProduct from './SeeProduct';
import Contact from './Contact';
import Menu from './Menu';
import { useEffect, useState } from 'react';
import Footer from './Footer';
import '../assets/footer.css'
import Pagination from './Pagination';
import { Link, useParams } from 'react-router-dom';



function Categories() {
  
  const [produits, setProduits] = useState([{
    id: 1,
    nom: "Gelato HHCP 7%",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/gelato.png",
    category:"fleurs"
  },{
    id: 2,
    nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
    prix: "7,00€ - 6,00€/g ",
    note: "4,5",
    avis: "8",
    image: "/images/produits/pack.png",
    category:"fleurs"
  },{
    id: 3,
    nom: "Fruity Punch HHC 50% + CBD 10%",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/fruity.png",
    category:"fleurs"
  },{
    id: 4,
    nom: "Runtz HHC 50% + 10% CBD",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/runz.png",
    category:"fleurs"
  },{
    id: 5,
    nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
    prix: "7,00€ - 6,00€/g ",
    note: "4,5",
    avis: "8",
    image: "/images/produits/pack.png",
    category:"parfum"
  },
  {
    id: 6,
    nom: "Gelato HHCP 7%",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/gelato.png",
    category:"parfum"
  },{
    id: 7,
    nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
    prix: "7,00€ - 6,00€/g ",
    note: "4,5",
    avis: "8",
    image: "/images/produits/pack.png",
    category:"parfum"
  },{
    id: 8,
    nom: "Fruity Punch HHC 50% + CBD 10%",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/fruity.png",
    category:"parfum"
  },{
    id: 9,
    nom: "Runtz HHC 50% + 10% CBD",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/runz.png",
    category:"fleurs"
  },
  {
    id: 10,
    nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
    prix: "7,00€ - 6,00€/g ",
    note: "4,5",
    avis: "8",
    image: "/images/produits/pack.png",
    category:"fleurs"
  }
]);

const trie =[
  {category:"Meilleures ventes"}, 
  {category:"Prix croissant"}, 
  {category:"Prix décroissant"}, 
  {category:"De la plus récente à la plus ancienne"}
];
  const category=[
    {
      id: 1,
      name: "BEST SELLERS",
      title: "Vos gammes CBD et HHC préférées ",
      image:"/images/header/best-sellers.jpg",
      product: produits,
    },
    {
      id: 2,
      name: "NOUVEAUTÉS",
      title: "Les dernières nouveautés pour vous satisfaire  ",
      image:"/images/header/nouveaute.jpg",
      product: produits,
    },
    {
      id: 3,
      name: "FLEURS",
      title: "CBD, CBG, HHC, HHCP, HHCO il y en a pour tout les goûts avec",
      image:"/images/header/fleur.png",
      product: produits,
    },
    {
      id: 4,
      name: "RÉSINES",
      title: "Résines et pollen de CBD & HHC puissantes ou douces",
      image:"/images/header/resine.jpg",
      product: produits,
    },
    {
      id: 5,
      name: "HUILES",
      title: "Huile CBD, CBG, HHC, Culinaire",
      image:"/images/header/huile.jpg",
      product: produits,
    },
    {
      id: 6,
      name: "COMESTIBLES",
      title: "Les bienfaits du CBD à travers des thés, tisanes, bonbons, huiles pour vos plats en cuisine",
      image:"/images/header/commestible.jpg",
      product: produits,
    },
    {
      id: 7,
      name: "E-liquide",
      title: "E-liquide HHC et E-liquide HHC ainsi que le matériel adapté",
      image:"/images/header/e-liquide.jpg",
      product: produits,
    },
    {
      id: 8,
      name: "E-CIGARETTE",
      title: "Pod HHC, pod CBD, Puff, cigarette électronique HHC et CBD",
      image:"/images/header/e-cigarette.png",
      product: produits,
    },
    {
      id: 9,
      name: "VAPORISATEUR",
      title: "Idéal pour la vaporisation de CBD/HHC",
      image:"/images/header/vaporisateur.jpg",
      product: produits,
    },
    {
      id: 10,
      name: "SOINS",
      title: "Pour une meilleure récupération musculaire",
      image:"/images/header/soins.jpg",
      product: produits,
    },
    {
      id: 11,
      name: "ANIMAUX",
      title: "Parce que eux aussi ont le droit au CBD",
      image:"/images/header/animaux.jpg",
      product: produits,
    },
  ];

  const categories=[
    {
      id: 1,
      name: "Fleurs Indoor",
    },
    {
      id: 2,
      name: "Fleurs Outdoor",
    },
    {
      id: 3,
      name: "Fleurs HHC",
    },
    {
      id: 4,
      name: "Fleurs HHCP",
    },
    {
      id: 5,
      name: "Fleurs HHCO",
    },
    {
      id: 6,
      name: "Fleurs qualité premium",
    },
    {
      id: 7,
      name: "Fleurs qualité greenhouse",
    }
  ];
  const [selectedCategory, setSelectedCategory] = useState();
  let params = useParams();
  const [current_cat, setCurrent_cat] = useState([]);

  function handleCategoryChange(event) {
    setSelectedCategory(event.target.value);
    setProduits(getFilteredList);
 }

 function getFilteredList() {
  if (!selectedCategory) {
    return produits;
  }
  return produits.filter((item) => item.category === selectedCategory);
}


// pagination

// L'utilisateur est actuellement sur cette page 
const [currentPage, setCurrentPage] = useState(1);
// Nombre d'enregistrements à afficher sur chaque page    
const [recordsPerPage, setRecordsPerPage] = useState(12);

// indice du dernier enregistrement
const indexOfLastRecord = currentPage * recordsPerPage;

// indice du premier enregistrement
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

let tabProduct = [];
 category.map(function(cat){
  cat.product.map(prod=>{
    tabProduct.push(prod);
  })
})
// sous ensemble du tableau par 10 item
const currentRecords = tabProduct.slice(indexOfFirstRecord, indexOfLastRecord);
const nPages = Math.ceil(tabProduct.length / recordsPerPage);

useEffect(()=>{
  let cat = category.filter(cat => cat.id === parseInt(params.id));
  if (cat) {     
    setCurrent_cat(cat[0])
  }
  setRecordsPerPage(12);
}, [])

  return (
    <div>
      <Menu />
      {/* Entete */}
        {current_cat && <HeaderCat title={ current_cat.name } subtitle={ current_cat.title} image={current_cat.image} />}
      {/* end entete  */}

      {/* categorie */}
      <div className='container category-product filter_item' id="categoryProduct">
        {/* popup filter */}
        <div className='mb-5 dropend noHover cat-drop ' id='filter-cat-product'>
          <a className='start dropdown-toggle filter-title' data-bs-toggle="dropdown" type='button' id="dropdownMenuLinkCat">
            <img src={window.location.origin +"/images/Vector.png"} className="me-1" alt="" /> 
          <span className='start'>Trier et filtre</span> </a>
            <ul className="dropdown-menu cat-drop-menu col-md-6" aria-labelledby="dropdownMenuLinkCat">
              <li><span className="filter-text dropdown-item mb-1">Filter </span></li>
              {
                categories.map((cat, index) => <li key={index}>
                  <span className="dropdown-item">
                    <input onChange={handleCategoryChange} className='checkbox' type="checkbox" value={cat.name}/> <span className='noHover'>{cat.name}</span>
                  </span>
                </li>)
              }
              <span className="filter-text dropdown-item mb-1 mt-2">Trier </span>
              {
                trie.map((trie, index) => <li key={index}>
                  <span className="dropdown-item">
                    <input className='checkbox' type="checkbox" value={trie.category}/> <span className='noHover'>{trie.category}</span>
                  </span>
                </li>)
              }
            </ul>
          <span className='end'>{tabProduct.length} produits</span>  
        </div>
         
        {/* list product */}
        <div className="cat-body">
          {
            currentRecords.map((prod, index) => <div className="cat-item" key={index}>
                <Link className='item-title' to={"/produit/"+prod.id}><img src={prod.image} alt="" /></Link>
                <h3 className='item-title'><Link className='item-title' to={"/produit/"+prod.id}>{prod.nom}</Link></h3>
                <p className='item-price'>{prod.prix} </p>
                <p className='item-note'>
                  <span> {prod.note}</span> <span><img src={window.location.origin +"/images/start.png"} alt="" /></span><span className='avis'> {prod.avis} avis</span>
                  </p>
            </div>)
          }   
        </div>

        {/* pagination */}
        <Pagination
              nPages={nPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
        {/* end pagination */}
      </div>

      {/* Faq */}
        <FaqCategorie/>
      {/* Faq */}

      {/* see product */}
        <SeeProduct/>
      {/* end see product */}

      {/* see product */}
        <Contact/>
      {/* end see product */}

      {/* see product */}
      <Footer/>
      {/* end see product */}
    </div>
  )
}

export default Categories